export default __webpack_public_path__ + "static/media/mercedes_offer2.8fce182a.jpg";